// @owners { team: patients }
import { useQuery } from '@tanstack/react-query';
import getShowProgynySelfServiceForUser from '~shared/features/users/selectors/getShowProgynySelfServiceForUser';
import { queries } from '~shared/queries/query-keys';
import { useSelectorShared } from '~shared/store';
import { getBackgroundColorFromConfig } from '../helpers/getBackgroundColorFromConfig';
import { onboardingBackgroundColor } from '../helpers/onboardingBackgroundColor';

export const useQueryLandingPageConfigs = ({ tempPassword }: { tempPassword: string }) => {
  const showProgyny = useSelectorShared(getShowProgynySelfServiceForUser);
  const queryResult = useQuery(queries.onboardingConfigs.fetchLandingPage({ params: { temp_password: tempPassword } }));
  const { isFetching, isSuccess, data, isError } = queryResult;

  const partnershipName = data?.data?.partnership_name;
  const backgroundColorConfig = data?.data?.background_color;

  const configuredBackgroundColor = getBackgroundColorFromConfig(backgroundColorConfig);
  const headerBackgroundColor = onboardingBackgroundColor(partnershipName, showProgyny, configuredBackgroundColor);

  return {
    isFetching,
    isSuccess,
    isError,
    headerBackgroundColor,
    headerLogoUrl: data?.data?.header_logo_url,
    partnershipName: data?.data?.partnership_name,
    welcomeImageUrl: data?.data?.welcome_image_url,
    welcomeHeader: data?.data?.welcome_header,
    welcomeBody: data?.data?.welcome_body,
    callToActionText: data?.data?.call_to_action_text,
    callToActionUrl: data?.data?.call_to_action_url,
  };
};
